import { render, staticRenderFns } from "./SectionSticky.vue?vue&type=template&id=27895b4c&"
import script from "./SectionSticky.vue?vue&type=script&lang=js&"
export * from "./SectionSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports